<div class="m-4 px-6 pb-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 bg-white flex flex-col gap-4">
      <div
        class="p-4 text-general-title text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      >
        {{ 'general-pages.capture-data-suppliers.title' | translate }}
      </div>
      <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        <div class="col-span-full">
          {{ 'general-pages.capture-data-suppliers.tenencia' | translate }}
        </div>

        <app-input-general-select
          [label]="'general-pages.capture-data-suppliers.proveedor' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.proveedor' | translate"
          [inputSelect]="{ value: 'iD_PROVEEDOR', description: 'denominacion' }"
          [arrayData]="proveedores"
        ></app-input-general-select>

        <app-input-general
          [label]="'general-pages.capture-data-suppliers.noFactura' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.noFactura' | translate"
        ></app-input-general>

        <app-input-general-calendar
          [label]="'general-pages.capture-data-suppliers.fechaFactura' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.fechaFactura' | translate"
        ></app-input-general-calendar>

        <app-input-general
          [label]="'general-pages.capture-data-suppliers.monto' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.monto' | translate"
        ></app-input-general>
        <app-input-general
          [label]="'general-pages.capture-data-suppliers.modalidadPago' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.modalidadPago' | translate"
        ></app-input-general>

        <div class="col-span-full">
          {{ 'general-pages.capture-data-suppliers.placasDerechos' | translate }}
        </div>

        <app-input-general-select
          [inputSelect]="{ value: 'iD_PROVEEDOR', description: 'denominacion' }"
          [arrayData]="proveedores"
          [label]="'general-pages.capture-data-suppliers.proveedor' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.proveedor' | translate"
        ></app-input-general-select>

        <app-input-general
          [label]="'general-pages.capture-data-suppliers.noFactura' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.noFactura' | translate"
        ></app-input-general>

        <app-input-general-calendar
          [label]="'general-pages.capture-data-suppliers.fechaFactura' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.fechaFactura' | translate"
        ></app-input-general-calendar>

        <app-input-general
          [label]="'general-pages.capture-data-suppliers.monto' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.monto' | translate"
        ></app-input-general>
        <app-input-general
          [label]="'general-pages.capture-data-suppliers.modalidadPago' | translate"
          [placeholder]="'general-pages.capture-data-suppliers.modalidadPago' | translate"
        ></app-input-general>
        <div class="col-span-full">
          {{ 'general-pages.capture-data-suppliers.verificacion' | translate }}
        </div>

        <app-input-general-select
          [label]="'Proveedor'"
          [placeholder]="'Proveedor'"
          [inputSelect]="{ value: 'iD_PROVEEDOR', description: 'denominacion' }"
          [arrayData]="proveedores"
        ></app-input-general-select>

        <app-input-general
          [label]="'No. Factura'"
          [placeholder]="'No. Factura'"
        ></app-input-general>

        <app-input-general-calendar
          [label]="'Fecha Factura'"
          [placeholder]="'Fecha Factura'"
        ></app-input-general-calendar>

        <app-input-general [label]="'Monto'" [placeholder]="'Monto'"></app-input-general>
        <app-input-general
          [label]="'Modalidad de Pago'"
          [placeholder]="'Modalidad de Pago'"
        ></app-input-general>
        <div class="col-span-full">GESTORIA</div>

        <app-input-general-select
          [label]="'Proveedor'"
          [placeholder]="'Proveedor'"
          [inputSelect]="{ value: 'iD_PROVEEDOR', description: 'denominacion' }"
          [arrayData]="proveedores"
        ></app-input-general-select>

        <app-input-general
          [label]="'No. Factura'"
          [placeholder]="'No. Factura'"
        ></app-input-general>

        <app-input-general-calendar
          [label]="'Fecha Factura'"
          [placeholder]="'Fecha Factura'"
        ></app-input-general-calendar>

        <app-input-general [label]="'Monto'" [placeholder]="'Monto'"></app-input-general>
        <app-input-general
          [label]="'Modalidad de Pago'"
          [placeholder]="'Modalidad de Pago'"
        ></app-input-general>
      </div>
    </div>
  </div>
</div>
